module.exports = __webpack_public_path__ + "img/punto_red_icon_new.14c35dbb.png";